module.exports = __webpack_public_path__ + "img/left.258c1c16.png";